import {
  FavoritesAPIType,
  FavoritesTypename,
  FloorTypename,
  FloorsAPIType,
  ProductPositionTypename,
  ProductPositionsAPIType,
  ProjectTypename,
  ProjectsAPIType,
  RoomTypename,
  RoomsAPIType
} from "shared/types/Project"

import {
  ClarificationRequestTypename,
  ClarificationRequestsAPIType
} from "entities/clarification-requests/types/ClarificationRequest"
import { UsersAPIType } from "entities/team-members/types/TeamMember"

export function mapAPITypeToTypename(
  typename: string | undefined
): string | null {
  switch (typename) {
    case ProjectsAPIType:
      return ProjectTypename
    case FloorsAPIType:
      return FloorTypename
    case RoomsAPIType:
      return RoomTypename
    case ProductPositionsAPIType:
      return ProductPositionTypename
    case FavoritesAPIType:
      return FavoritesTypename
    case ClarificationRequestsAPIType:
      return ClarificationRequestTypename
    case UsersAPIType:
      return "User"
    default:
      return null
  }
}
